export const BRAND = 'Makeup Instructor Ready'

/** Checkout button label — the only place the price appears. */
export const CHECKOUT_LABEL = 'Oui, je veux gagner du temps — 27 USD'

export const heroTopics = ['Cours', 'Techniques', 'Exercices', 'Évaluations', 'Gestion de classe']

/** The six-stage pathway across the volumes. */
export const systemFlow = ['Connaître', 'Enseigner', 'Planifier', 'Pratiquer', 'Évaluer', 'Gérer']

export const volumes = [
  { number: '1', stage: 'Connaître', title: 'La Science du Maquillage et les Fondamentaux pour Formateurs' },
  { number: '2', stage: 'Enseigner', title: 'Techniques d’Enseignement et Animation de Classe' },
  { number: '3', stage: 'Planifier', title: 'Planification de Cours et Création de Programmes' },
  { number: '4', stage: 'Pratiquer', title: 'Pratique Élève et Développement des Compétences' },
  { number: '5', stage: 'Évaluer', title: 'Évaluation, Appréciation et Feedback' },
  { number: '6', stage: 'Gérer', title: 'Gérer Votre Activité de Formation en Maquillage' },
]

/** Real Volume 4 pages. */
export const galleryPages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/pzPJJj9E5XGxEXeCjtuXGQ/makeup_instructor_ready_vol4_fr_page_17.webp',
    title: 'Module 9 — Cartographie des yeux & estompe',
    word: 'Comprendre',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ocWcu5FMrzsjLgRFbbZEmZ/makeup_instructor_ready_vol4_fr_page_13.webp',
    title: 'Module 6 — Cartographie du visage & dimension',
    word: 'Planifier',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7CPxFip4EHATUMwpWUXsKb/makeup_instructor_ready_vol4_fr_page_28.webp',
    title: 'Brief Client — Exercice',
    word: 'Appliquer',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hPE9mTtHq43aNtSji4KB5a/makeup_instructor_ready_vol4_fr_page_36.webp',
    title: 'Module 17 — Journal de pratique & preuves de progrès',
    word: 'Suivre',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2c3wkdcXaqHsAaJijC7su2/makeup_instructor_ready_vol4_fr_page_47.webp',
    title: 'La compétence se construit dans la répétition intentionnelle',
    word: 'Progresser',
  },
]

export const bonuses = [
  { number: 'Bonus 1', title: 'Bibliothèque de Face Charts' },
  { number: 'Bonus 2', title: '50 Activités de Cours de Maquillage Prêtes à l’Emploi' },
  { number: 'Bonus 3', title: 'Guide de Référence Rapide du Formateur' },
  { number: 'Bonus 4', title: '50 Idées de Cours Prêtes à Enseigner' },
  { number: 'Bonus 5', title: 'Pack Professionnel de Documents à Imprimer' },
]

export const audience = [
  'Formatrices en maquillage',
  'Makeup Educators',
  'Professeures en école de beauté',
  'Propriétaires d’académies',
  'Maquilleuses professionnelles qui enseignent',
  'Professionnelles souhaitant commencer à former',
]

export const faqs = [
  {
    question: 'Est-ce une formation de maquillage ?',
    answer: 'Non. C’est un système pédagogique pour les professionnelles qui enseignent le maquillage.',
  },
  {
    question: 'Puis-je l’utiliser immédiatement ?',
    answer: 'Oui. Choisissez les ressources adaptées à votre prochain cours et intégrez-les à votre préparation.',
  },
  {
    question: 'Est-ce adapté aux nouvelles formatrices ?',
    answer: 'Oui. Il peut également aider une maquilleuse professionnelle à structurer son enseignement.',
  },
  {
    question: 'Que vais-je recevoir ?',
    answer: '6 volumes principaux + 5 bonus.',
  },
  {
    question: 'Les fichiers sont-ils modifiables ?',
    answer: 'Non. Les ressources sont fournies en PDF finalisés.',
  },
  {
    question: 'Y a-t-il un abonnement ?',
    answer: 'Non. C’est un paiement unique avec un accès immédiat.',
  },
]
